<template>
    <div :class="item.customClass" :style="promoStyleObject" class="promoSpot">
          <component
            :is="itemHref ? 'a' : 'div'"
            :href="itemHref"
            :data-cktag="item.description"
            :alt="item.alt_text || item.title || (itemHref ? 'Promo Link' : 'Promo Content')">
            <div :style="imageStyleObject" class="itemImage">
              <img loading="lazy" :src="imgSrc" :alt="altText">
            </div>
            <h3 class="" v-if="item.title && item.title.length > 0"><span>{{item.title}}</span></h3>
            <div class="text" style="display: block;">{{item.flavorText}}</div>
        </component>
    </div>
</template>


<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true,
        default: () => ({}),
      },
      assetHost: {
        type: String,
        required: true,
        default: () => (''),
      },
    },
    data() {
      return {
        promoOpacity: 0,
      };
    },
    computed: {
      altText: function(){
        return this.item.alt_text || this.item.title || this.item.description || '';
      },
      imgSrc: function(){
        return this.$store.state.cmsHost + this.item.image_url;
      },
      imageStyleObject: function () {
        if (typeof this.item.image_url === 'undefined') {
          return { display: 'none' };
        } else {
          if(this.promoOpacity === 1) {
            return {
              display: 'block',
            };
          } else {
            return { display: 'none' };
          }

        }

      },
      promoStyleObject: function () {
        return {
          display: 'block',
          opacity: this.promoOpacity,
        };
      },
      itemHref: function(){
        let itemHref = this.item.link_url && this.item.link_url.length > 0 ? this.item.link_url : null;
        return itemHref;
      }
    },
    mounted() {
      this.promoOpacity = 1;
    },
  };
</script>

<style>
    .promoSpot {
        transition: opacity .3s;
    }
    .promoSpot .itemImage {
      overflow: hidden;
    }
</style>
